import React from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from '@hookform/resolvers/zod';
import * as z from "zod";

import { useDispatch } from "react-redux";

import * as salesforceManagerActions from "../../../redux/SalesforceManagers/actions.js";

import PageBase from "../../../components/PageBase/index";
import Toaster from "../../../components/Toaster";

import "./salesforce-manager.scss";

const schema = z.object({
  packageUrl: z.string().min(1, 'Production URL Package is required').url(),
  sandboxPackageUrl: z.string().min(1, 'Sandbox URL Package is required').url(),
});

const SalesforceManagers = (props) => {
  const dispatch = useDispatch();
  const [salesforceManager, setSalesforceManager] = React.useState(null);
  const {
    reset,
    register,
    handleSubmit,
    formState: { errors, isDirty, isValid, isSubmitting },
  } = useForm({
    defaultValues: {
      packageUrl: "",
      sandboxPackageUrl: "",
    },
    mode: "onChange",
    resolver: zodResolver(schema),
  });

  const handleGetSalesforceManager = React.useCallback(() => {
    dispatch(salesforceManagerActions.getSalesforceManagers((data) => {
      setSalesforceManager(data?.[0] || null);
      reset({
        packageUrl: data?.[0]?.package_url || "",
        sandboxPackageUrl: data?.[0]?.sandbox_package_url || "",
      });
    }));
  }, [dispatch, reset]);

  const onSave = (data) => {
    try {
      dispatch(salesforceManagerActions.saveSalesforceManager({
        id: salesforceManager?.id || null,
        packageUrl: data.packageUrl,
        sandboxPackageUrl: data.sandboxPackageUrl,
      }, (data) => {
        if (data?.status === 'ok') {
          handleGetSalesforceManager();
          return;
        }
      }));
      Toaster.showSuccess("Salesforce Installation URL Package saved successfully.");
    } catch (e) {
      Toaster.showError("Submit error!!!");
      return;
    }
  };

  React.useEffect(() => {
    handleGetSalesforceManager();
  }, [handleGetSalesforceManager]);

  return (
    <PageBase title="Salesforce Managers" removeMargins>
      <form className="salesforce-manager-form" onSubmit={handleSubmit(onSave)}>
        <div className="salesforce-manager-form__group">
          <label className="salesforce-manager-form__label">Production URL Package:</label>
          <input
            type="text"
            className="salesforce-manager-form__input"
            placeholder="Enter Production URL Package"
            {...register("packageUrl")}
          />

          {errors.packageUrl && <p className="salesforce-manager-form__error">{errors.packageUrl.message}</p>}
        </div>

        <div className="salesforce-manager-form__group">
          <label className="salesforce-manager-form__label">Sandbox URL Package:</label>
          <input
            type="text"
            className="salesforce-manager-form__input"
            placeholder="Enter Sandbox URL Package"
            {...register("sandboxPackageUrl")}
          />
          {errors.sandboxPackageUrl && <p className="salesforce-manager-form__error">{errors.sandboxPackageUrl.message}</p>}
        </div>

        <div className="salesforce-manager-form__group">
          <button disabled={!isDirty || !isValid || isSubmitting} type="submit" className="salesforce-manager-form__button">Save</button>
        </div>
      </form>
    </PageBase>
  )
}

export default SalesforceManagers;